import { useQuery, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import { useBackendAuthenticated } from "@/hooks/useBackendAuthenticated";

const FacilityResponseSchema = z.object({
  success: z.boolean(),
  data: z.record(z.string(), z.unknown()),
});

export function useFacility() {
  const backend = useBackendAuthenticated();
  return useQuery({
    queryKey: ["facility"],
    queryFn: async () => {
      const json = await backend({ method: "GET", url: "/api/v1/facility" });
      return FacilityResponseSchema.parse(json).data;
    },
  });
}

export function useSaveFacility() {
  const backend = useBackendAuthenticated();
  return useMutation({
    mutationFn: (values: Record<string, string>) =>
      backend({ method: "PATCH", url: "/api/v1/facility", data: values }),
  });
}
